import { z } from 'zod';
import { zDateRequired, zStringRequired } from '../z';
export const PDGMSchema = z.object({
    SectionA: z
        .object({
        m0030: zDateRequired(),
        m0032: z.iso.date().nullish(),
        m0100: zStringRequired(),
        m1000: z.array(zStringRequired()).nonempty(),
    })
        .superRefine((values, ctx) => {
        if (values.m0100 === '03' && !values.m0032) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: 'required',
            });
        }
    }),
    SectionG: z.object({
        m1800: zStringRequired(),
        m1810: zStringRequired(),
        m1820: zStringRequired(),
        m1830: zStringRequired(),
        m1840: zStringRequired(),
        m1850: zStringRequired(),
        m1860: zStringRequired(),
    }),
    SectionI: z.object({
        m1021: z.object({
            code: zStringRequired(),
        }),
        m1023: z.array(z.object({
            code: zStringRequired(),
        })),
    }),
    SectionJ: z.object({
        m1033: z.array(zStringRequired()).nonempty(),
    }),
});
